import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferFragmentDoc, FastOfferFragmentDoc } from '../fragments/Offer.fragment';
export type GetTitleOffersQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	filterFlatrate: Types.OfferFilter;
	filterBuy: Types.OfferFilter;
	filterRent: Types.OfferFilter;
	filterFree: Types.OfferFilter;
	filterDvdBluRay: Types.OfferFilter;
	platform?: Types.Platform;
}>;

export type GetTitleOffersQuery = {
	__typename?: 'Query';
	node?:
		| { __typename: 'Article'; id: string }
		| { __typename: 'Author'; id: string }
		| { __typename: 'Bundle'; id: string }
		| { __typename: 'Device'; id: string }
		| {
				__typename: 'Episode';
				offerCount: number;
				maxOfferUpdatedAt?: any | null;
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				buy: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				rent: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				free: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				fast: Array<{
					__typename?: 'Offer';
					availableTo?: any | null;
					availableFromTime?: any | null;
					availableToTime?: any | null;
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				dvdBluRay: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				bundles: Array<{
					__typename?: 'PromotedBundleEdge';
					promotionUrl: string;
					node: {
						__typename?: 'Bundle';
						id: string;
						clearName: string;
						icon: string;
						technicalName: string;
						bundleId: number;
						shortName: string;
						packages: Array<{
							__typename?: 'Package';
							icon: string;
							iconWide: string;
							id: string;
							clearName: string;
							packageId: number;
						}>;
					};
					offer: {
						__typename?: 'Offer';
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							technicalName: string;
							packageId: number;
							clearName: string;
							shortName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								retailPriceConverted?: string | null;
								retailPriceValue?: number | null;
								currency?: string | null;
								presentationType?: Types.PresentationType | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
				}>;
		  }
		| { __typename: 'GenericTitleList'; id: string }
		| { __typename: 'Genre'; id: string }
		| { __typename: 'HomePage'; id: string }
		| {
				__typename: 'Movie';
				offerCount: number;
				maxOfferUpdatedAt?: any | null;
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				buy: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				rent: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				free: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				fast: Array<{
					__typename?: 'Offer';
					availableTo?: any | null;
					availableFromTime?: any | null;
					availableToTime?: any | null;
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				dvdBluRay: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				bundles: Array<{
					__typename?: 'PromotedBundleEdge';
					promotionUrl: string;
					node: {
						__typename?: 'Bundle';
						id: string;
						clearName: string;
						icon: string;
						technicalName: string;
						bundleId: number;
						shortName: string;
						packages: Array<{
							__typename?: 'Package';
							icon: string;
							iconWide: string;
							id: string;
							clearName: string;
							packageId: number;
						}>;
					};
					offer: {
						__typename?: 'Offer';
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							technicalName: string;
							packageId: number;
							clearName: string;
							shortName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								retailPriceConverted?: string | null;
								retailPriceValue?: number | null;
								currency?: string | null;
								presentationType?: Types.PresentationType | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
				}>;
		  }
		| { __typename: 'MultiStepSportEvent'; id: string }
		| { __typename: 'Offer'; id: string }
		| { __typename: 'OfferHistory'; id: string }
		| { __typename: 'Package'; id: string }
		| { __typename: 'Page'; id: string }
		| { __typename: 'Person'; id: string }
		| { __typename: 'ProfileV2'; id: string }
		| {
				__typename: 'Season';
				offerCount: number;
				maxOfferUpdatedAt?: any | null;
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				buy: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				rent: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				free: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				fast: Array<{
					__typename?: 'Offer';
					availableTo?: any | null;
					availableFromTime?: any | null;
					availableToTime?: any | null;
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				dvdBluRay: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				bundles: Array<{
					__typename?: 'PromotedBundleEdge';
					promotionUrl: string;
					node: {
						__typename?: 'Bundle';
						id: string;
						clearName: string;
						icon: string;
						technicalName: string;
						bundleId: number;
						shortName: string;
						packages: Array<{
							__typename?: 'Package';
							icon: string;
							iconWide: string;
							id: string;
							clearName: string;
							packageId: number;
						}>;
					};
					offer: {
						__typename?: 'Offer';
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							technicalName: string;
							packageId: number;
							clearName: string;
							shortName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								retailPriceConverted?: string | null;
								retailPriceValue?: number | null;
								currency?: string | null;
								presentationType?: Types.PresentationType | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
				}>;
		  }
		| {
				__typename: 'Show';
				offerCount: number;
				maxOfferUpdatedAt?: any | null;
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				buy: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				rent: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				free: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				fast: Array<{
					__typename?: 'Offer';
					availableTo?: any | null;
					availableFromTime?: any | null;
					availableToTime?: any | null;
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				dvdBluRay: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							retailPriceConverted?: string | null;
							retailPriceValue?: number | null;
							currency?: string | null;
							presentationType?: Types.PresentationType | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				bundles: Array<{
					__typename?: 'PromotedBundleEdge';
					promotionUrl: string;
					node: {
						__typename?: 'Bundle';
						id: string;
						clearName: string;
						icon: string;
						technicalName: string;
						bundleId: number;
						shortName: string;
						packages: Array<{
							__typename?: 'Package';
							icon: string;
							iconWide: string;
							id: string;
							clearName: string;
							packageId: number;
						}>;
					};
					offer: {
						__typename?: 'Offer';
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							technicalName: string;
							packageId: number;
							clearName: string;
							shortName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								retailPriceConverted?: string | null;
								retailPriceValue?: number | null;
								currency?: string | null;
								presentationType?: Types.PresentationType | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
				}>;
		  }
		| { __typename: 'SingleStepSportEvent'; id: string }
		| { __typename: 'SportCompetitionV2'; id: string }
		| { __typename: 'SportCompetitorV2'; id: string }
		| { __typename: 'SportMatch'; id: string }
		| { __typename: 'Url'; id: string }
		| { __typename: 'UserProviderSubscription'; id: string }
		| null;
};

export const GetTitleOffersDocument = gql`
	query GetTitleOffers(
		$nodeId: ID!
		$country: Country!
		$language: Language!
		$filterFlatrate: OfferFilter!
		$filterBuy: OfferFilter!
		$filterRent: OfferFilter!
		$filterFree: OfferFilter!
		$filterDvdBluRay: OfferFilter!
		$platform: Platform! = WEB
	) {
		node(id: $nodeId) {
			id
			__typename
			... on MovieOrShowOrSeasonOrEpisode {
				offerCount(country: $country, platform: $platform)
				maxOfferUpdatedAt(country: $country, platform: $platform)
				flatrate: offers(country: $country, platform: $platform, filter: $filterFlatrate) {
					...TitleOffer
				}
				buy: offers(country: $country, platform: $platform, filter: $filterBuy) {
					...TitleOffer
				}
				rent: offers(country: $country, platform: $platform, filter: $filterRent) {
					...TitleOffer
				}
				free: offers(country: $country, platform: $platform, filter: $filterFree) {
					...TitleOffer
				}
				fast: offers(
					country: $country
					platform: $platform
					filter: { monetizationTypes: [FAST], bestOnly: true }
				) {
					...FastOffer
				}
				dvdBluRay: offers(country: $country, platform: $platform, filter: $filterDvdBluRay) {
					...TitleOffer
				}
				bundles(country: $country, platform: WEB) {
					node {
						id
						clearName
						icon(profile: S100)
						technicalName
						bundleId
						shortName
						packages(country: $country, platform: $platform) {
							icon
							iconWide(profile: S160)
							id
							clearName
							packageId
						}
					}
					promotionUrl
					offer {
						...TitleOffer
						package {
							id
							technicalName
						}
					}
				}
			}
		}
	}
	${TitleOfferFragmentDoc}
	${FastOfferFragmentDoc}
`;
